/* eslint-disable consistent-return */
/* eslint-disable no-return-await */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import instance from "services/axiosServices";

interface ParamsProps {
  idsZonasEmpreendimento: string[];
}

export function useListarBairrosEmpreendimentos(body: ParamsProps) {
  const registerData = async () => {
    const LISTAR_BAIRROS_EMPREENDIMENTOS = `locais/app-web/bairros-empreendimentos/v1/`;
    return await instance.post(LISTAR_BAIRROS_EMPREENDIMENTOS, body);
  };
  const query = useMutation({
    mutationFn: async () => await registerData(),
    mutationKey: ["listar_bairros_empreendimentos"],
    onError: (error: any) => {
      const errorMessages = error.response.data.notifications.map(
        (item: any) => `\n${item?.message}\n`
      );

      toast.error(errorMessages.join(""), { autoClose: 10000 });
    },
  });
  return query;
}
